module.exports = "<h2>Using a Full URL File Path</h2>\n<img src=\"https://www.w3schools.com/images/picture.jpg\" alt=\"Mountain\" style=\"width:300px\">\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/share/sharing/sharing.component.html
// module id = 1038
// module chunks = 6